define(function (require) {
    
    require('jquery.validate');
    
    function checkRegNumber(value) {
        try {
            var a = 0;
            if (value.length == 0)
                return true;
            if (value.length != 8)
                throw 1;
            var b = value.split('');
            var c = 0;
            for (var i = 0; i < 7; i++)
                a += (parseInt(b[i]) * (8 - i));
            a = a % 11;
            c = 11 - a;
            if (a == 1)
                c = 0;
            if (a == 0)
                c = 1;
            if (a == 10)
                c = 1;
            if (parseInt(b[7]) != c)
                throw (1);
        } catch (e) {
            return false;
        }
        return true;
    }
    
    function checkDate(date){
        console.log(date);
        return date.match(/^(((0?[1-9]|[12]\d|3[01])\.(0[13578]|[13578]|1[02])\.((1[6-9]|[2-9]\d)\d{2}))|((0?[1-9]|[12]\d|30)\.(0[13456789]|[13456789]|1[012])\.((1[6-9]|[2-9]\d)\d{2}))|((0?[1-9]|1\d|2[0-8])\.0?2\.((1[6-9]|[2-9]\d)\d{2}))|(29\.0?2\.((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/i);
    }
    
    function checkTime(time){
        return time.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/i);
    }

    $.validator.addMethod("regnumber", function (value, element) {
        return checkRegNumber(value);
    }, "");
    $.validator.addMethod("taxregnumber", function (value, element) {

        try {
            if (value.length == 0)
                return true;
            var id = value.substr(0, 2).toUpperCase();
            value = value.substr(2);
            if ((id == 'CZ') || (id == 'SK')) {
                if (value.length < 8)
                    throw 1;
                if (value.length > 11)
                    throw 1;
                if (value.length == 8) {
                    return checkRegNumber(value);
                }
                throw 1;
            }
            return true;
        } catch (e) {
            return false;
        }
    }, "");

    $.validator.addMethod("personalidentificationnumber", function (value, element) {
        var age = 0;
        try {
            if (value.length == 0)
                return true;
            if (value.length < 9)
                throw 1;
            var year = parseInt(value.substr(0, 2), 10);
            var month = parseInt(value.substr(2, 2), 10);
            var day = parseInt(value.substr(4, 2), 10);
            var ext = parseInt(value.substr(6, 3), 10);
            if ((value.length == 9) && (year < 54))
                return true;
            var c = 0;
            if (value.length == 10)
                c = parseInt(value.substr(9, 1));
            var m = parseInt(value.substr(0, 9)) % 11;
            if (m == 10)
                m = 0;
            if (m != c)
                throw 1;
            year += (year < 54) ? 2000 : 1900;
            if ((month > 70) && (year > 2003))
                month -= 70;
            else if (month > 50)
                month -= 50;
            else if ((month > 20) && (year > 2003))
                month -= 20;
            var d = new Date();
            if ((year + age) > d.getFullYear())
                throw 1;
            if (month == 0)
                throw 1;
            if (month > 12)
                throw 1;
            if (day == 0)
                throw 1;
            if (day > 31)
                throw 1;
        } catch (e) {

            return false;
        }
        return true;
    }, "Please specify correct personal identification number");

    $.validator.addMethod("alpha", function (value, element) {
        return this.optional(element) || value.match(/^[a-žA-Ž]*$/i);
    }, "");


    $.validator.addMethod("alphawithspace", function (value, element) {
        return this.optional(element) || value.match(/^[a-žA-Ž\s]*$/i);
    }, "");

    $.validator.addMethod("street", function (value, element) {
        return this.optional(element) || value.match(/^[a-žA-Ž\s\.]*$/i);
    }, "");

    $.validator.addMethod("alphanumwithspace", function (value, element) {
        return this.optional(element) || value.match(/^[a-žA-Ž\s\d]*$/i);
    }, "");

    $.validator.addMethod("alphadash", function (value, element) {
        return this.optional(element) || value.match(/^[a-žA-Ž\.\s\d]*$/i);
    }, "");

    $.validator.addMethod("matches", function (value, element, param) {
        return this.optional(element) || (value == param);
    }, "");

    $.validator.addMethod("exactlength", function (value, element, param) {
        return this.optional(element) || (value.length == param);
    }, "");

    $.validator.addMethod("greaterthan", function (value, element, param) {
        return this.optional(element) || (value > param);
    }, "");

    $.validator.addMethod("lessthan", function (value, element, param) {
        return this.optional(element) || (value < param);
    }, "");

    $.validator.addMethod("dateeu", function (value, element) {
        console.log(value);
        return this.optional(element) || checkDate(value)
    }, "");
    
    $.validator.addMethod("time", function (value, element) {
        return this.optional(element) || checkTime(value)
    }, "");
    
    $.validator.addMethod("datetime", function (value, element) {
        
        var parts = value.split(' ');
        
        return this.optional(element) || (checkDate(parts[0]) && checkTime(parts[1]))
    }, "");
    
    $.validator.addMethod("boolean", function (value, element) {
        return this.optional(element) || (value == 0 || value == 1)
    }, "");

    $.validator.addMethod("postcode", function (value, element) {
        /*if( ! value.length){  return false;}*/
        //removes placeholder from string
        value = value.split("_").join("");

        var splitted = value.split(' ');

        for (var i in splitted) {
            if ((parseFloat(splitted[i]) != parseInt(splitted[i])) && isNaN(splitted[i])) {
                return false;
            }
        }
        return true;
    }, "");
    
    return {};
});